import {
    GLOBAL_SEARCH, IS_LOADING_SEARCH, SEARCH_FRIENDS, IS_LOADING_SEARCH_FRIENDS
} from './types'

import inMemoryJWT from '../auth/inMemoryJwt';
import { urlServer } from '../config/GlobalConstant'
import localStorage from '../utils/hooks/useLocalStorage';


//search actions, search friends and all users
export const searchAction = (text, model="user") => async dispatch => {
    await fetch(`${urlServer}search/full-search`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            textString: text,
            model: model,
            limit: 10,
            skip: 0

        }) // body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_SEARCH
            });
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GLOBAL_SEARCH,
                payload: respJson.data[0]
            });

        })
        .catch(error => {
            console.log()
        })

}



export const searchFriends = (text, isFollowing, isFollowers, isProfessional) => async dispatch => {

    const accessToken = inMemoryJWT.getToken()
      

    isProfessional ?
        await fetch(`${urlServer}api/social/search-contacts`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            },
            body: JSON.stringify({
                
                idUser: localStorage().getItem("professionalID")

            }) // body data type must match "Content-Type" header      
        })
            .then(response => response.json())
            .then(respJson => {
                console.log()
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_SEARCH_FRIENDS
                });
                if(respJson.success ){
                    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                        type: SEARCH_FRIENDS,
                        payload: respJson.data.filter(data=>console.log())
                    });
                }else{
                    dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                        type: SEARCH_FRIENDS,
                        payload:    []
                    });
                }
                

            })
            .catch(error => {
                console.log()
            })
        :
        await fetch(`${urlServer}social/get-social-list`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            },
            body: JSON.stringify({
                type: 1,
                idUser: localStorage().getItem("idProfile")

            }) // body data type must match "Content-Type" header      
        })
            .then(response => response.json())
            .then(respJson => {
                console.log()
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: IS_LOADING_SEARCH_FRIENDS
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: SEARCH_FRIENDS,
                    payload: respJson.data//.filter(([id,{user}])=>user.name.toLowerCase().includes(text))
                });

            })
            .catch(error => {
                console.log()
            })

}



